module.exports = __webpack_public_path__ + "static/img/666.e62cca6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/666.png
// module id = xpwC
// module chunks = 12